<template>
  <div class="page-content">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PageContent'
}
</script>

<style scoped>
.page-content {
  padding: 22px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/page/PageContent.vue